import { Redirect } from "react-router-dom"

import useAuth from "../../hooks/useAuth"
import LogoutTimerModal from "../../assets/shared/page/modal/LogoutTimerModal"
import { RoutePaths } from "../../routes/RoutePaths"
import { useChatContext } from "../../assets/js/features/chat/state/context/ChatContext"
import { useEffect } from "react"
import { getUserPermission } from "../../assets/js/app/state/appSessionStorage"
import { getTenantName } from "../../assets/js/features/token/TokenEncryption"

// eslint-disable-next-line react/prop-types
const AuthGuard = ({ children }) => {
  const { isLoggedIn } = useAuth()

  const {connected, connect} = useChatContext()

  const userPermission = getUserPermission()

  useEffect(() => {
    if(!connected && userPermission) {
      connect(userPermission.userId)
    }
  }, [connected])

  if (!isLoggedIn) {
    const tenantName = getTenantName();
    if (tenantName) {
      return <Redirect to={'/' + tenantName + RoutePaths.SIGN_IN} />
    } else {
      return <Redirect to={RoutePaths.SIGN_IN} />
    }
  }

  return <>
    {children}
    <LogoutTimerModal />
  </>
}

export default AuthGuard
